var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer" },
    [
      _vm.showSubscription && !_vm.LOGGED_IN
        ? _c("subscription-block")
        : _vm._e(),
      _c("main-block"),
      _c("copyright-block")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }